import { CamposGenericos } from "./camposGenericos"

export class Region extends CamposGenericos {
    descripcion:string
    id:string
    idCompania:string
    idPais:string
    idSalesOrg:string
    usuarioCoordinadorVentas:string
}
